/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from 'react';
import { AdSlotRow } from '../collection-templates/ad-slot-row';
import { CustomWidgetRow } from '../collection-templates/custom-widget-row';

const StoryRowWrapper = ({ rows, storyId, storySlug, children, isStoryInfiniteScrollEnabled }) => {
  if (!rows.length) {
    rows = [
      {
        rowId: 1603877816292,
        type: 'story',
        config: {},
        pageType: 'story'
      }
    ];
  }

  const renderedRows = rows.map((row, index) => {
    const key = row.rowId || index;
    if (!global.qtLoadedFromShell) {
      switch (row.type) {
        case 'widget':
          return (
            <div id={`widget-${row.rowId}_${storyId}`} data-story-id={storyId} key={key}>
              <CustomWidgetRow storyId={storyId} metadata={row} />
            </div>
          );
        case 'ads':
          return (
            <div id={`ad-${row.rowId}_${storyId}`} key={key}>
              <AdSlotRow metadata={{ ...row, ...{ storyId, isStoryInfiniteScrollEnabled } }} />
            </div>
          );
        case 'story':
          return <React.Fragment key={key}>{children}</React.Fragment>;
      }
    }

    switch (row.type) {
      case 'widget':
        return <CustomWidgetRow metadata={row} key={key} />;
      case 'ads':
        return <AdSlotRow metadata={{ ...row, ...{ storyId, isStoryInfiniteScrollEnabled } }} key={key} />;
      case 'story':
        return <React.Fragment key={key}>{children}</React.Fragment>;
    }
  });

  return (
    <div className="story-row-container" data-story-slug={storySlug} data-story-id={storyId}>
      {renderedRows}
    </div>
  );
};

export default StoryRowWrapper;
